import { memo } from 'react';
import { Skeleton } from '@bonanza-social/moonlight';

function PrizeWallHeaderImageSkeleton() {
  return (
    <Skeleton
      height="100%"
      marginHorizontal="auto"
      maxWidth={160}
      aspectRatio={4}
    />
  );
}

export default memo(PrizeWallHeaderImageSkeleton);
